import {Component, HostListener, signal} from '@angular/core';

@Component({
    selector: 'app-to-top-button',
    imports: [],
    template: `
    @if (windowScrolled() && !isCabinet) {
      <div class="fixed bottom-4 right-3" tabindex="0" (click)="scrollToTop()">
        <img class="cursor-pointer w-10 h-10" src="/images/icons/arrow-up-blue.svg" alt="">
      </div>
    }
  `,
    styles: ``
})
export class ToTopButtonComponent {
  windowScrolled = signal(false);

  @HostListener('window:scroll', ['$event']) onScroll() {
    this.windowScrolled.set(window.scrollY >= 100);
  }

  scrollToTop(): void {
    window.scrollTo(0, 0);
  }

  get isCabinet() {
    return window.location.pathname.includes('cabinet');
  }
}
